export enum PriceSource {
    /**
     * Pick original price from f_price field in NomenclaturePositionEntity
     * @see backend-php/modules/rest_common/models/nomenclature/PriceValue.php:103
     */
    PRICE_BASE_VALUE = 0,

    /**
     * Pick price from PriceValueEntity.priceValue
     * @see backend-php/modules/rest_common/models/nomenclature/PriceValue.php:101
     */
    PRICE_VALUE = 1,

    /**
     * Not implemented!
     * @see backend-php/modules/rest_common/models/nomenclature/PriceValue.php:105
     */
    PRICE_TYPE_DISCOUNT = 2,

    /**
     * Not implemented!
     * @see backend-php/modules/rest_common/models/nomenclature/PriceValue.php:105
     */
    PRICE_DISCOUNT = 3,
}
